import { motion } from 'framer-motion';
import { useAppStore } from '../store';

export function Jack2Button() {
  const { jack2Open, setJack2Open } = useAppStore();

  return (
    <motion.button
      onClick={() => setJack2Open(!jack2Open)}
      className="fixed bottom-6 right-6 z-50"
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
      title="Jack2 AI Assistant"
    >
      <div className="relative">
        {/* Glow effect */}
        <div className="absolute inset-0 bg-jrd-orange rounded-full blur-lg opacity-30 animate-pulse" />

        {/* Robot icon */}
        <div
          className={`relative w-14 h-14 rounded-full flex items-center justify-center transition-all ${
            jack2Open ? 'bg-jrd-green' : 'bg-jrd-orange'
          }`}
        >
          <svg viewBox="0 0 32 32" className="w-8 h-8 text-white">
            {/* Robot head */}
            <rect x="6" y="8" width="20" height="16" rx="2" fill="currentColor" />
            {/* Eyes */}
            <motion.circle
              cx="11"
              cy="14"
              r="2"
              fill="#0A0A0F"
              animate={{ scaleY: [1, 0.1, 1] }}
              transition={{ duration: 0.15, repeat: Infinity, repeatDelay: 3 }}
            />
            <motion.circle
              cx="21"
              cy="14"
              r="2"
              fill="#0A0A0F"
              animate={{ scaleY: [1, 0.1, 1] }}
              transition={{ duration: 0.15, repeat: Infinity, repeatDelay: 3 }}
            />
            {/* Mouth - straight line */}
            <rect x="10" y="19" width="12" height="2" rx="1" fill="#0A0A0F" />
            {/* Tie */}
            <path d="M16 24 L14 28 L16 30 L18 28 Z" fill="#2D5A3D" />
          </svg>
        </div>

        {/* Status dot */}
        <div className="absolute -top-1 -right-1 w-4 h-4 bg-jrd-green rounded-full border-2 border-bg-dark">
          <div className="w-full h-full rounded-full bg-jrd-green animate-ping opacity-75" />
        </div>
      </div>
    </motion.button>
  );
}
